import { Dispatch } from "redux";
import { DiditInitActionTypes, DiditInitCreateAction } from "../../types/Payments/diditInit";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const diditInit = (): any => {
    return async (dispatch: Dispatch<DiditInitCreateAction>) => {
        try {
            dispatch({ type: DiditInitActionTypes.POST_DIDIT_INIT_DATA });

            const response = await axios.post(
                "https://didit-test.replit.app/api/didit/session",
                {
                    workflowId: "1a0be448-5007-4016-b250-91d212325705",
                    callback: "https://bet365.betstack.io/zimpler"
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            dispatch({
                type: DiditInitActionTypes.POST_DIDIT_INIT_DATA_SUCCESS,
                payload: response.data
            });

            console.log("Didit response:", response.data);

            if (response.data?.url) {
                window.location.href = response.data.url;
            }

        } catch (error: any) {
            let errorPayload: ErrorResponse;

            if (error.response?.data) {
                errorPayload = {
                    code: error.response.data.code ?? -1,
                    message: error.response.data.message ?? "Didit error"
                };
            } else {
                errorPayload = { code: -1, message: "Unknown error occurred" };
            }

            dispatch({
                type: DiditInitActionTypes.POST_DIDIT_INIT_DATA_ERROR,
                payload: errorPayload
            });
        }
    };
};